module.exports = __webpack_public_path__ + "static/bluewhale5-cf67b2fdcb96f670628304b0a1746d77.png";